__turbopack_context__.v({
  "colLeft": "xymhsG_colLeft",
  "colRight": "xymhsG_colRight",
  "dFlex": "xymhsG_dFlex",
  "plus": "xymhsG_plus",
  "plusLine": "xymhsG_plusLine",
  "plusNumber": "xymhsG_plusNumber",
  "title": "xymhsG_title",
});
